export const tr = {
    'all-audience': 'Tüm hedef kitle',
    'by-selected-region': 'Seçilen bölgede',
    metrikaAudience: 'Yandex.Audience ve Yandex.Metrica',
    'users-profiles': 'Kullanıcı profili'
};
